import React, { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { MdDownload, MdIosShare } from "react-icons/md";
import { useLocation } from "react-router-dom";
import logo from "../assets/logo.png";

const InstallInstructions = () => (
  <div className="flex flex-col justify-center items-center p-6 bg-white rounded-lg" dir="rtl">
    <img src={logo} alt="لوگو برنامه" className="mb-6 w-24 h-24" />
    <h2 className="text-xl font-bold mb-4 text-gray-800">برای نصب وب‌اپلیکیشن مراحل زیر را انجام دهید</h2>
    <ol className="w-full max-w-md text-right space-y-4 text-gray-700 text-base leading-relaxed">
      <li className="flex items-center">
        <span className="flex-none">1-</span>
        <span className="flex-1">
          در نوار پایینی روی دکمه <MdIosShare className="inline-block mx-1 text-xl" /> Share ضربه بزنید
        </span>
      </li>
      <li className="flex items-center">
        <span className="flex-none">2-</span>
        <span className="flex-1">در منوی بازشده گزینه <strong>Add to Home Screen</strong> را انتخاب کنید</span>
      </li>
      <li className="flex items-center">
        <span className="flex-none">3-</span>
        <span className="flex-1">
          در مرحله بعد روی دکمه <FiPlus className="inline-block mx-1 text-xl" /> Add ضربه بزنید
        </span>
      </li>
    </ol>
  </div>
);

const InstallButton = ({ forceShow = false }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [isIosDevice, setIsIosDevice] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showIosModal, setShowIosModal] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const ua = window.navigator.userAgent;
    const isiOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    setIsIosDevice(isiOS);
  }, []);

  useEffect(() => {
    const checkInstalled =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    setIsInstalled(checkInstalled);
  }, []);

  useEffect(() => {
    if (isIosDevice || isInstalled) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowButton(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, [isIosDevice, isInstalled]);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowButton(false);
  };

  const isLoginRoute = location.pathname === "/login";

  if ((!forceShow && !isLoginRoute) || isInstalled) return null;

  if (isIosDevice) {
    return showIosModal ? (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-2xl max-w-md w-full relative">
          <button
            onClick={() => setShowIosModal(false)}
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
          <InstallInstructions />
        </div>
      </div>
    ) : null;
  }

  if (!showButton && !forceShow) return null;

  const disabled = !deferredPrompt && !forceShow;

  return (
    <div className="flex items-center space-x-2" dir="rtl">
      <button
        onClick={handleInstallClick}
        disabled={disabled}
        className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        <MdDownload className="text-xl" />
        <span>نصب وب‌اپلیکیشن</span>
      </button>
    </div>
  );
};

export default InstallButton;
